import { HyamPrismicNextJsApp, HyamPrismicDocumentFooter } from "hyam-prismic/components";
import "../styles/globals.css";

HyamPrismicNextJsApp.configure({
  FooterComponent: HyamPrismicDocumentFooter,
});

export default HyamPrismicNextJsApp;
